// Option for the intersection observer
const observerOptions = {
  root: null,
  threshold: 0,
}

/**
 * This is a way to show / hide the topbar accordion to it being sticky or not.
 * Johannes wanted us to show the topbar only when it gets sticky.
 * Before the user scroll enough for it to get sticky it should be hidden.
 *
 * The way we do this is:
 *     - we added an empty div with 'inpage-nav__marker--top' class immediately before the inpage nav element
 *     - we add an intersection observer to this marker element
 *     - react to the marker intersection and add an attribute to the inpage nav when necessary
 */
export default function initInpageNavVisibility() {
  const markerTop = document.querySelector('.inpage-nav__marker--top');
  const navbar = document.querySelector('.inpage-nav');
  if (!markerTop || !navbar) return;

  const observer = new IntersectionObserver(([entry]) => {
    observerHandler(entry, navbar)
  }, observerOptions)

  observer.observe(markerTop);
}

/**
 * Toggle 'inpage-nav--isvisible' according to the marker being above the screen or not
 * @param entry
 * @param navbar
 */
function observerHandler(entry, navbar) {
  if (entry.isIntersecting) {
    navbar.removeAttribute('inpage-nav--isvisible');
    return
  }
  if (entry.boundingClientRect.top < 0) {
    navbar.setAttribute('inpage-nav--isvisible', '');
  }
}
